import { Client } from '../types';
import { Get } from './helpers/builder';

export const getAllCurrentAanbiederClients = Get`/clients/providers/${'provider_id'}/current`.json<{response: Client[]}>();
